document.addEventListener('DOMContentLoaded', function() {
  // Only run on the homepage
  const isHomePage = window.location.pathname === '/' || 
                     window.location.pathname === '/index' || 
                     document.body.classList.contains('template-index');
  
  if (!isHomePage) return;
  
  console.log('Homepage cart fix active');
  
  // Look for the cart trigger
  const cartTrigger = document.querySelector('.js-cart-trigger');
  
  if (!cartTrigger) {
    console.warn('Cart trigger not found on homepage');
    return;
  }
  
  console.log('Found cart trigger on homepage');
  
  // Create a direct, high-priority click handler for the homepage
  const directClickHandler = function(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('Cart button clicked on homepage');
    
    // First, try to find cart-drawer
    const cartDrawer = document.querySelector('cart-drawer');
    
    if (cartDrawer) {
      console.log('Found cart-drawer element');
      
      // Try to open it with method if available
      if (typeof cartDrawer.open === 'function') {
        console.log('Using open() method');
        cartDrawer.open();
      } 
      // Otherwise set attribute manually - this will trigger the mutation observer
      else {
        console.log('Setting open attribute manually');
        cartDrawer.setAttribute('open', '');
        cartDrawer.style.display = 'flex';
        
        // Make body unscrollable
        document.body.style.overflow = 'hidden';
      }
      
      // Dispatch required events manually to ensure shipping bar updates
      setTimeout(function() {
        const cartChangedEvent = new CustomEvent('afterCartChanged');
        const updateQuantityEvent = new CustomEvent('afterUpdateQuantity');
        
        document.dispatchEvent(cartChangedEvent);
        document.dispatchEvent(updateQuantityEvent);
      }, 300);
      
      return false;
    }
    
    // Fallback: direct to cart page if drawer not found
    console.log('Cart drawer not found, redirecting to cart page');
    window.location.href = '/cart';
    return false;
  };
  
  // Apply our handler, using capture phase to ensure it runs first
  // Remove any existing click handlers first
  cartTrigger.onclick = null;
  
  // Then add our new handler
  cartTrigger.addEventListener('click', directClickHandler, true);
  
  console.log('Direct cart handler installed');
  
  // Also try a backup approach - add inline onclick
  cartTrigger.setAttribute('onclick', "event.preventDefault(); document.querySelector('cart-drawer').setAttribute('open', ''); document.body.style.overflow='hidden'; console.log('Inline handler fired');");
});